<template>
  <b-container class="p-3" fluid>
    <b-alert v-if="(project.gallery.length < 10 || project.gallery.length > 20) && $auth.user().role === 'coordinator' && project.status === 'DraftForCloseProjectApproval'" variant="info" show>
      <font-awesome-icon icon="info" />
      กรุณาอัปโหลดรูปภาพกิจกรรมจำนวน 10 - 20 ภาพ (ปัจจุบัน {{ project.gallery.length }} ภาพ)
    </b-alert>
    <b-row>
      <b-col>
        <gallery-upload-field v-if="$auth.user().role === 'coordinator' && project.status === 'DraftForCloseProjectApproval'" class="mb-4" :is-uploading="isUploading" @submit="submit" />
        <gallery-table :galleries="project.gallery" @finish="$apollo.queries.project.refetch()" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import gql from 'graphql-tag'

import GalleryUploadField from '@/components/project/evaluation/gallery/GalleryUploadField'
import GalleryTable from '@/components/project/evaluation/gallery/GalleryTable'

export default {
  apollo: {
    project: {
      query: gql`query GetProject($id: ID!) { project(id: $id) { status gallery { image, caption} } }`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  components: {
    GalleryUploadField,
    GalleryTable
  },
  data () {
    return {
      isUploading: false
    }
  },
  methods: {
    async submit (file) {
      this.isUploading = true
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $file: Upload!, $caption: String) { projectGalleryAdd(id: $id, file: $file, caption: $caption) { id } }`,
        variables: { id: this.$route.params.id, file: file.image, caption: file.caption }
      }).then(() => {
        this.$bvToast.toast('อัปโหลดรูปภาพสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })
        file.image = ''
        file.caption = ''
        this.isUploading = false
      }).catch((error) => {
        let { graphQLErrors } = error
        if (graphQLErrors[0].extensions.category === 'validation') {
          this.errorMessage = graphQLErrors[0].extensions.validation.file[0]
        } else {
          this.errorMessage = 'เกิดข้อผิดพลาดในการอัปโหลด'
        }
        this.$bvToast.toast(this.errorMessage, {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      })
      this.refetch()
    },
    refetch () {
      this.$apollo.queries.project.refetch()
    }
  }
}
</script>

<style>

</style>
